import React from "react";
import { connect } from "react-redux";
import { Row, Label } from "reactstrap";
import ElementWrapper from "../../../components/element/ElementWrapper/ElementWrapper";
import { Droppable } from "react-beautiful-dnd";
import { elementConstants } from "../../../../constants/cms/form/element/element.constants";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import '../../../style/ContentStyles.css'
import AccountBoxOutlinedIcon from '@material-ui/icons/AccountBoxOutlined';
import ElementDropItem from "../../../components/editor/ElementDropItem/ElementDropItem";

class UserPageElements extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            collapse: false,
            elements: null
        };
    }
    toggle() {
        this.setState(state => ({ collapse: !state.collapse }));
    }
    render() {
        return (
            <div className="element-list-aside" >
                <Droppable isDropDisabled={true} droppableId={"sidebar-labels"}>
                    {provided => (
                        <div ref={provided.innerRef}>
                            <Row style={{ margin: '10px', }} ><Label><SystemLabel name="UserPage" /></Label><i className="fa fa-help" /></Row>
                            <Row style={{ margin: '10px', display: 'inline-block' }} >
                                <ElementWrapper
                                    id={`${elementConstants.USER_PAGE}`}
                                    index={0}
                                >
                                    <ElementDropItem
                                        name={'UserPage'}
                                        draggableId={`${elementConstants.USER_PAGE}`}
                                        row={false}
                                        userLabel={false}
                                        icon={
                                            <AccountBoxOutlinedIcon
                                                style={{
                                                    fontSize: "40px",
                                                    padding: "5px 0px"
                                                }}
                                            />
                                        }
                                    />
                                </ElementWrapper>
                            </Row>
                        </div>)}
                </Droppable>
            </div >
        );
    }
}

function mapStateToProps(state) {
    return {
        alert: state.alert,
        cElements: state.element,
        template: state.template,
        page: state.page,
        form: state.form
    };
}

export default connect(mapStateToProps)(UserPageElements);
